import { takeEvery, fork, put, all, call, delay } from "redux-saga/effects"
import * as types from "./constant"
import { createCompTargetFail, createCompTargetSuccess, createLOBTargetFail, createLOBTargetSuccess, createMonthlyTargetFail, createMonthlyTargetSuccess, createYearlyTargetFail, createYearlyTargetSuccess, getComMonthlyFail, getComMonthlySuccess, getComYearlyFail, getComYearlySuccess, getCompTargetFail, getCompTargetSuccess, getEmpTargetFail, getEmpTargetSuccess, getLOBTargetFail, getLOBTargetSuccess, getLobMonthlyFail, getLobMonthlySuccess, getLobYearlyFail, getLobYearlySuccess, getMonthlyChartFail, getMonthlyChartSuccess, getMonthlyTargetFail, getMonthlyTargetSuccess, getYearlyChartFail, getYearlyChartSuccess, getYearlyTargetFail, getYearlyTargetSuccess, updateCompTargetFail, updateCompTargetSuccess, updateLOBTargetFail, updateLOBTargetSuccess, updateMonthlyTargetFail, updateMonthlyTargetSuccess, updateYearlyTargetFail, updateYearlyTargetSuccess } from "./action"
import { createCompTargetAPI, createLOBTargetAPI, createMonthlyTargetAPI, createYearlyTargetAPI, getComMonthlyAPI, getComYearlyAPI, getCompTargetAPI, getEmpTargetAPI, getLOBTargetAPI, getLobMonthlyAPI, getLobYearlyAPI, getMonthlyChartAPI, getMonthlyTargetAPI, getYearlyChartAPI, getYearlyTargetAPI, updateCompTargetAPI, updateLOBTargetAPI, updateMonthlyTargetAPI, updateyearlyTargetAPI } from "./api"


function* createMonthlyTargetAsync(action) {
  try {
    const response = yield call(createMonthlyTargetAPI, action.payload)
    if (response.status === 200 || 201) {
      delay(500)
        console.log(response.data)
      yield put(createMonthlyTargetSuccess(response.data))
    } else {
        yield put(createMonthlyTargetFail(response.data))
    }
  } catch (error) {
    yield put(createMonthlyTargetFail(error.response.data))
  }
}

function* createMonthlyTarget() {
  yield takeEvery(types.CREATE_MONTHLY_TARGET_START, createMonthlyTargetAsync)
}


function* getMonthlyTargetAsync(action) {
  try {
    const response = yield call(getMonthlyTargetAPI, action.payload)
    if (response.status === 200 || 201) {
      delay(500)
      yield put(getMonthlyTargetSuccess(response.data.targets))
    } else {
        yield put(getMonthlyTargetFail(response.data))
    }
  } catch (error) {
    yield put(getMonthlyTargetFail(error.response.data))
  }
}

function* getMonthlyTarget() {
  yield takeEvery(types.GET_MONTHLY_TARGET_START, getMonthlyTargetAsync)
}

function* updateMonthlyTarAsync(action) {
  try {
    const response = yield call(updateMonthlyTargetAPI, action.payload)
    if (response.status === 200 || 201) {
      delay(500)
        console.log(response.data)
      yield put(updateMonthlyTargetSuccess(response.data))
    } else {
        yield put(updateMonthlyTargetFail(response.data))
    }
  } catch (error) {
    console.log(error)
    yield put(updateMonthlyTargetFail(error.response.data))
  }
}

function* updateMonthlyTar() {
  yield takeEvery(types.UPDATE_MONTHLY_TARGET_START, updateMonthlyTarAsync)
}



function* createYearlyTargetAsync(action) {
  try {
    const response = yield call(createYearlyTargetAPI, action.payload)
    if (response.status === 200 || 201) {
      delay(500)
        console.log(response.data)
      yield put(createYearlyTargetSuccess(response.data))
    } else {
        yield put(createYearlyTargetFail(response.data))
    }
  } catch (error) {
    yield put(createYearlyTargetFail(error.response.data))
  }
}

function* createYearlyTarget() {
  yield takeEvery(types.CREATE_YEARLY_TARGET_START, createYearlyTargetAsync)
}

function* getYearlyTargetAsync(action) {
  try {
    const response = yield call(getYearlyTargetAPI, action.payload)
    if (response.status === 200 || 201) {
      delay(500)
        console.log(response.data)
      yield put(getYearlyTargetSuccess(response.data))
    } else {
        yield put(getYearlyTargetFail(response.data))
    }
  } catch (error) {
    yield put(getYearlyTargetFail(error.response.data))
  }
}

function* getYearlyTarget() {
  yield takeEvery(types.GET_YEARLY_TARGET_START, getYearlyTargetAsync)
}

function* updateYearlyTargetAsync(action) {
  try {
    const response = yield call(updateyearlyTargetAPI, action.payload)
    if (response.status === 200 || 201) {
      delay(500)
        console.log(response.data)
      yield put(updateYearlyTargetSuccess(response.data))
    } else {
        yield put(updateYearlyTargetFail(response.data))
    }
  } catch (error) {
    yield put(updateYearlyTargetFail(error.response.data))
  }
}

function* updateYearlyTarget() {
  yield takeEvery(types.UPDATE_YEARLY_TARGET_START, updateYearlyTargetAsync)
}

function* createCompTargetAsync(action) {
  try {
    const response = yield call(createCompTargetAPI, action.payload)
    if (response.status === 200 || 201) {
      delay(500)
        console.log(response.data)
      yield put(createCompTargetSuccess(response.data))
    } else {
        yield put(createCompTargetFail(response.data))
    }
  } catch (error) {
    yield put(createCompTargetFail(error.response.data))
  }
}

function* createCompTarget() {
  yield takeEvery(types.CREATE_COMP_TARGET_START, createCompTargetAsync)
}


function* getCompTargetAsync(action) {
  try {
    const response = yield call(getCompTargetAPI, action.payload)
    if (response.status === 200 || 201) {
      delay(500)
        console.log(response.data)
      yield put(getCompTargetSuccess(response.data.targets))
    } else {
        yield put(getCompTargetFail(response.data))
    }
  } catch (error) {
    yield put(getCompTargetFail(error.response.data))
  }
}

function* getCompTarget() {
  yield takeEvery(types.GET_COMP_TARGET_START, getCompTargetAsync)
}


function* updateCompTargetAsync(action) {
  try {
    const response = yield call(updateCompTargetAPI, action.payload)
    if (response.status === 200 || 201) {
      delay(500)
        console.log(response.data)
      yield put(updateCompTargetSuccess(response.data))
    } else {
        yield put(updateCompTargetFail(response.data))
    }
  } catch (error) {
    yield put(updateCompTargetFail(error.response.data))
  }
}

function* updateCompTarget() {
  yield takeEvery(types.UPDATE_COMP_TARGET_START, updateCompTargetAsync)
}


function* getEmpTargetAsync(action) {
  try {
    const response = yield call(getEmpTargetAPI, action.payload)
    if (response.status === 200 || 201) {
      delay(500)
        console.log(response.data)
      yield put(getEmpTargetSuccess(response.data))
    } else {
        yield put(getEmpTargetFail(response.data))
    }
  } catch (error) {
    console.log(error)
    yield put(getEmpTargetFail(error.response.data))
  }
}

function* getEmpTarget() {
  yield takeEvery(types.GET_EMP_TARGET_START, getEmpTargetAsync)
}


function* createLOBTargetAsync(action) {
  try {
    const response = yield call(createLOBTargetAPI, action.payload)
    if (response.status === 200 || 201) {
      delay(500)
        console.log(response.data)
      yield put(createLOBTargetSuccess(response.data))
    } else {
        yield put(createLOBTargetFail(response.data))
    }
  } catch (error) {
    yield put(createLOBTargetFail(error.response.data))
  }
}

function* createLOBTarget() {
  yield takeEvery(types.CREATE_LOB_TARGET_START, createLOBTargetAsync)
}


function* getLOBTargetAsync(action) {
  try {
    const response = yield call(getLOBTargetAPI, action.payload)
    if (response.status === 200 || 201) {
      delay(500)
        console.log(response.data)
      yield put(getLOBTargetSuccess(response.data.targets))
    } else {
        yield put(getLOBTargetFail(response.data))
    }
  } catch (error) {
    yield put(getLOBTargetFail(error.response.data))
  }
}

function* getLOBTarget() {
  yield takeEvery(types.GET_LOB_TARGET_START, getLOBTargetAsync)
}


function* UpdateLOBTargetAsync(action) {
  try {
    const response = yield call(updateLOBTargetAPI, action.payload)
    if (response.status === 200 || 201) {
      delay(500)
        console.log(response.data)
      yield put(updateLOBTargetSuccess(response.data))
    } else {
        yield put(updateLOBTargetFail(response.data))
    }
  } catch (error) {
    yield put(updateLOBTargetFail(error.response.data))
  }
}

function* UpdateLOBTarget() {
  yield takeEvery(types.UPDATE_LOB_TARGET_START, UpdateLOBTargetAsync)
}


function* getComMonthlyAsync() {
  try {
    const response = yield call(getComMonthlyAPI)
    if (response.status === 200 || 201) {
      delay(500)
        console.log(response.data)
      yield put(getComMonthlySuccess(response.data))
    } else {
        yield put(getComMonthlyFail(response.data))
    }
  } catch (error) {
    yield put(getComMonthlyFail(error.response.data))
  }
}

function* getComMonthly() {
  yield takeEvery(types.GET_COM_MONTHLY_START, getComMonthlyAsync)
}


function* getComYearlyAsync() {
  try {
    const response = yield call(getComYearlyAPI)
    if (response.status === 200 || 201) {
      delay(500)
        console.log(response.data)
      yield put(getComYearlySuccess(response.data))
    } else {
        yield put(getComYearlyFail(response.data))
    }
  } catch (error) {
    yield put(getComYearlyFail(error.response.data))
  }
}

function* getComYearly() {
  yield takeEvery(types.GET_COM_YEARLY_START, getComYearlyAsync)
}


function* getLobMonthlyAsync() {
  try {
    const response = yield call(getLobMonthlyAPI)
    if (response.status === 200 || 201) {
      delay(500)
        console.log(response.data)
      yield put(getLobMonthlySuccess(response.data))
    } else {
        yield put(getLobMonthlyFail(response.data))
    }
  } catch (error) {
    yield put(getLobMonthlyFail(error.response.data))
  }
}

function* getLobMonthly() {
  yield takeEvery(types.GET_LOB_MONTHLY_START, getLobMonthlyAsync)
}


function* getLobYearlyAsync() {
  try {
    const response = yield call(getLobYearlyAPI)
    if (response.status === 200 || 201) {
      delay(500)
        console.log(response.data)
      yield put(getLobYearlySuccess(response.data))
    } else {
        yield put(getLobYearlyFail(response.data))
    }
  } catch (error) {
    yield put(getLobYearlyFail(error.response.data))
  }
}

function* getLobYearly() {
  yield takeEvery(types.GET_LOB_YEARLY_START, getLobYearlyAsync)
}



function* getYearlyChartAsync() {
  try {
    const response = yield call(getYearlyChartAPI)
    if (response.status === 200 || 201) {
      delay(500)
        console.log(response.data)
      yield put(getYearlyChartSuccess(response.data))
    } else {
        yield put(getYearlyChartFail(response.data))
    }
  } catch (error) {
    yield put(getYearlyChartFail(error.response.data))
  }
}

function* getYearlyChart() {
  yield takeEvery(types.GET_YEARLY_CHART_START, getYearlyChartAsync)
}


function* getMonthlyChartAsync() {
  try {
    const response = yield call(getMonthlyChartAPI)
    if (response.status === 200 || 201) {
      delay(500)
        console.log(response.data)
      yield put(getMonthlyChartSuccess(response.data))
    } else {
        yield put(getMonthlyChartFail(response.data))
    }
  } catch (error) {
    yield put(getMonthlyChartFail(error.response.data))
  }
}

function* getMonthlyChart() {
  yield takeEvery(types.GET_MONTHLY_CHART_START, getMonthlyChartAsync)
}


function* targetSaga() {
    yield all([
      fork(createMonthlyTarget),
      fork(createYearlyTarget),
      fork(getLOBTarget),
      fork(createLOBTarget),
      fork(UpdateLOBTarget),
      fork(createCompTarget),
      fork(getCompTarget),
      fork(updateCompTarget),
      fork(getEmpTarget),
      fork(updateMonthlyTar),
      fork(updateYearlyTarget),
      fork(getYearlyTarget),
      fork(getMonthlyTarget),
      fork(getComMonthly),
      fork(getLobMonthly),
      fork(getLobYearly),
      fork(getComYearly),
      fork(getYearlyChart),
      fork(getMonthlyChart),
    ])
  }
  
  export default targetSaga
  